import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { routes } from "@/data/siteContent";

export const PathNavigator = () => {
  const trackRef = useRef(null); const { pathname } = useLocation();
  useEffect(() => { const active = trackRef.current?.querySelector('[aria-current="page"]'); active?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }); }, [pathname]);
  return (
  <nav className="path-rail" aria-label="Explore SHANE-AI" data-testid="path-navigator">
    <div className="path-rail-track" ref={trackRef}>
      {routes.map(({ path, label, mobileLabel, eyebrow, icon: Icon, color, depth, mobileOnly, primary }) => (
        <NavLink
          key={path}
          to={path}
          end={path === "/"}
          className={({ isActive }) => `path-stop ${mobileOnly ? "mobile-only-stop" : ""} ${primary ? "primary-path" : ""} ${isActive ? "is-active" : ""}`}
          style={{ "--stop-color": color }}
          data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-")}-link`}
        >
          {({ isActive }) => (
            <>
              {isActive && <motion.span layoutId="active-path" className="active-path" />}
              <span className="path-icon"><Icon size={22} strokeWidth={1.8} /></span>
              <span className="path-copy">
                <strong className="desktop-path-label">{label}</strong><strong className="mobile-path-label">{mobileLabel||label}</strong>
                <small>{depth === "deep" ? "◆ " : ""}{eyebrow}</small>
              </span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  </nav>
  );
};